var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditbtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2019 3.58498C10.5919 3.22279 11.1986 3.23402 11.575 3.6104L13.0147 5.05012C13.3911 5.4265 13.4023 6.03318 13.0401 6.42323L8.15385 11.6854C8.0415 11.8064 7.88385 11.8751 7.71875 11.8751H5.34375C5.01583 11.8751 4.75 11.6093 4.75 11.2814V8.90636C4.75 8.74125 4.81875 8.58361 4.93973 8.47126L10.2019 3.58498Z",
    fill: "#2c8ec6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 13.6564C4.75 13.3284 5.01583 13.0626 5.34375 13.0626H13.6562C13.9842 13.0626 14.25 13.3284 14.25 13.6564C14.25 13.9843 13.9842 14.2501 13.6562 14.2501H5.34375C5.01583 14.2501 4.75 13.9843 4.75 13.6564Z",
    fill: "#2c8ec6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditbtn);
export default __webpack_public_path__ + "static/media/editbtn.353a13a69e006ec281df4de91b7f101c.svg";
export { ForwardRef as ReactComponent };